// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingTable_root__1Zo3l","spinnerArea":"LoadingTable_spinnerArea__1769Y","visible":"LoadingTable_visible__6C4ZM"};